module.exports = __webpack_public_path__ + "img/lg_ring_g_s_null_null@2x.34552373.png";